import { render, staticRenderFns } from "./ManualTinderScansPage.vue?vue&type=template&id=41fe7a40&scoped=true"
import script from "./ManualTinderScansPage.vue?vue&type=script&lang=js"
export * from "./ManualTinderScansPage.vue?vue&type=script&lang=js"
import style0 from "./ManualTinderScansPage.vue?vue&type=style&index=0&id=41fe7a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fe7a40",
  null
  
)

export default component.exports